import types from "./types";

export const newsLetterSubscription = (payload) => ({
  type: types.NEWSLETTER,
  payload,
});

export const newsLetterSubscriptionResponse = (payload) => ({
  type: types.NEWSLETTER_RESPONSE,
  payload,
});


export const aboutUs = (payload) => ({
  type: types.ABOUT_US,
  payload,
});

export const aboutUsResponse = (payload) => ({
  type: types.ABOUT_US_RESPONSE,
  payload,
});

export const aboutUsResponseClear = (payload) => ({
  type: types.ABOUT_US_RESPONSE_CLEAR,
  payload,
});


export const contactUs = (payload) => ({
  type: types.CONTACT_US,
  payload,
});

export const contactUsResponse = (payload) => ({
  type: types.CONTACT_US_RESPONSE,
  payload,
});

export const contactUsResponseClear = (payload) => ({
  type: types.CONTACT_US_RESPONSE_CLEAR,
  payload,
});

export const helpUs = (payload) => ({
  type: types.HELP_US,
  payload,
});

export const helpUsResponse = (payload) => ({
  type: types.HELP_US_RESPONSE,
  payload,
});

export const helpUsResponseClear = (payload) => ({
  type: types.HELP_US_RESPONSE_CLEAR,
  payload,
});




